import { useCallback, useRef, useState } from 'react'
import styled from 'styled-components'
import { IconSettings } from 'components/Icons/IconSettings'
import { Menu } from 'components/Menu/Menu'
import { Typography } from 'components/Typography/Typography'
// import { LangPicker } from 'modules/LangPicker/LangPicker'
import { useOnClickOutside } from 'utils/onClickOutside'
import { IconNotification } from 'components/Icons/IconNotification'
import { AlertsDialog } from './AlertsDialog'
import Checkbox from 'components/Checkbox/Checkbox'
import { useAppTheme } from 'contexts/ThemeProviderContext'
import { useIsMobile } from 'utils/useIsMobile'
import { useIsTelegramConnected } from 'utils/useIsTelegramConnected'
import { useCurrentWalletAddress } from 'utils/useCurrentWalletAddress'

const SettingsDropdownMenuContainer = styled.div`
  position: relative;
  display: flex;
  margin-right: 24px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-right: 12px;
    .mobile {
      position: fixed;
      top: 80px !important;
      right: 16px;
      width: 300px !important;
    }
  }
`

// const LangContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `

export const IconContainer = styled.div`
  display: flex;
  cursor: pointer;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    & > svg {
      width: 24px !important;
      height: 24px !important;
    }
  }
`

export const Settings = () => {
  const walletAddress = useCurrentWalletAddress()

  const connectionStatus = useIsTelegramConnected()

  const isConnected = !!walletAddress

  const [isDialogOpen, setDialogOpen] = useState(false)

  const openDialog = () => setDialogOpen(true)
  const closeDialog = () => setDialogOpen(false)

  const [isMenuOpen, setMenuOpen] = useState(false)

  const menuNode = useRef<HTMLDivElement>(null)

  const onClose = useCallback(() => {
    if (!isDialogOpen) {
      setMenuOpen(false)
    }
  }, [isDialogOpen])

  useOnClickOutside(menuNode, onClose)

  const toggleMenu = useCallback(() => setMenuOpen(!isMenuOpen), [isMenuOpen])

  const isMobile = useIsMobile()

  const { theme, toggleTheme } = useAppTheme()

  return (
    <>
      <SettingsDropdownMenuContainer>
        <IconContainer onClick={toggleMenu}>
          <IconSettings />
        </IconContainer>
        {isMenuOpen && (
          <Menu anchorElement={menuNode} style={{ padding: 16, top: 40 }} className="mobile">
            <Typography variant="label2" fontWeight="semiBold" style={{ marginBottom: 16 }}>
              Settings
            </Typography>
            {/* <LangContainer>
              <Typography variant="description" fontWeight="light">
                Language
              </Typography>
              <LangPicker />
            </LangContainer> */}
            {isConnected && isMobile && (
              <div style={{ marginTop: 16, cursor: 'pointer' }} onClick={openDialog}>
                <Typography
                  variant="description"
                  fontWeight="light"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  {connectionStatus?.isConnected ? 'Disconnect Telegram' : 'Connect Telegram to get notifications'}
                  <IconNotification />
                </Typography>
              </div>
            )}
            <div style={{ marginTop: 16, cursor: 'pointer' }} onClick={toggleTheme}>
              <Typography
                variant="description"
                fontWeight="light"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
              >
                Dark Mode
                <Checkbox checked={theme === 'dark'} />
              </Typography>
            </div>
          </Menu>
        )}
      </SettingsDropdownMenuContainer>
      <AlertsDialog isOpen={isDialogOpen} onClose={closeDialog} />
    </>
  )
}
